import getApiClient from "../../../../shared/api";

export const FETCH_STORYBOARD = "FETCH_STORYBOARD";
export const SAVE_STORYBOARD_SETTINGS = "SAVE_STORYBOARD_SETTINGS";

export const fetchStoryboard = (filmId) => {
    return (dispatch) => {
        dispatch({
            type: FETCH_STORYBOARD,
            payload: getApiClient().get(`/film/${filmId}/storyboard`)
        });
    };
}

export const saveStoryboardSettings = (filmId, settings) => {
    return (dispatch) => {
        dispatch({
            type: SAVE_STORYBOARD_SETTINGS,
            payload: getApiClient().put(`/film/${filmId}/storyboard/settings`, settings)
        });
    };
}
